import Typography from "aldoo-ra/Typography"
import React from "react"
import MenuGroup from "aldoo-ra/MenuGroup"
import DynamicSVG from "aldoo-ra/DynamicSVG"



const PlatformsAvailable = ({ data }) => {
  return (
    <MenuGroup
      name="PlatformsAvailable"
      renderAs="hlist.icons"
      styleOverrides={{
        menu_item: "p-0 m-0 flex items-center justify-center",
        menu: "flex gap-3 py-0 my-0"
      }}
      listLabel={(data) => {
        return (
          <Typography 
            variant="body_24"
            className="text-gray_2 my-0"
          >{data.label}</Typography>
        )
      }}
      menuItemRender={(item) => {
        return (
          <div className="flex items-center">
            {item.image && (
              <DynamicSVG 
                url={item.image}
                className="w-[24px] h-[24px] text-primary hover:text-primary_hov transition duration-200"
              />
            )}
          </div>
        )
      }}
    />
  )
}

export default PlatformsAvailable
